import { FormSelectMultiple } from '@systemeio/ui'
import { TagInterface } from 'modules/newsletters/single/types/newsletter-interface'
import React from 'react'
import ButtonLikeLink from 'shared/components/button-like-link'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { ContactsSettings, ContactsSettingsBlockProps } from '.'
import { CloseIcon } from '@systemeio/ui/icons'

export interface TagsBlockProps
  extends Pick<ContactsSettingsBlockProps, 'isPreFetching' | 'disabled'> {
  title: string
  onChangeMultiselect: (
    value: ContactsSettings['tags']['excluded'] | ContactsSettings['tags']['included'],
  ) => void
  onClickTagLabel: (tagId: TagInterface['id']) => void
  onSelectAll: () => void
  onUnselectAll: () => void
  type?: 'included' | 'excluded'
  tagsList: ContactsSettings['tags']['excluded'] | ContactsSettings['tags']['included']
  listOfTagsOptions: { id: number; caption: string }[] | undefined
  required?: boolean
}

const TagsBlock = ({
  disabled,
  isPreFetching,
  title,
  required,
  onChangeMultiselect,
  onClickTagLabel,
  onSelectAll,
  onUnselectAll,
  type = 'included',
  tagsList,
  listOfTagsOptions,
}: TagsBlockProps) => {
  const { t } = useLocoTranslation()

  return (
    <div className={`bg-background-secondary flex w-full flex-col overflow-y-hidden rounded-md`}>
      <div className={`mt-5 flex flex-col gap-1`}>
        <FormSelectMultiple
          required={required}
          hideSelectedValues
          disabled={disabled}
          isPreFetching={isPreFetching}
          label={title}
          data={listOfTagsOptions}
          value={tagsList}
          onChange={onChangeMultiselect}
        />
        <div className="flex justify-end gap-1">
          <ButtonLikeLink
            disabled={disabled || isPreFetching}
            className={`${isPreFetching ? 'text-transparent' : ''}}`}
            onClick={onSelectAll}
          >
            {t('dashboard.contact_email_settings.tags_selector.select_all')}
          </ButtonLikeLink>
          |
          <ButtonLikeLink
            disabled={disabled || isPreFetching}
            className={`${isPreFetching ? 'text-transparent' : ''}}`}
            onClick={onUnselectAll}
          >
            {t('dashboard.contact_email_settings.tags_selector.unselect_all')}
          </ButtonLikeLink>
        </div>
      </div>
      {!isPreFetching && (
        <ul className={`mb-5 flex max-h-44 flex-wrap gap-1 overflow-auto pt-1`}>
          {tagsList.map(currentId => (
            <li
              key={currentId}
              className={`
              text-sm
              ${
                type === 'included'
                  ? 'bg-background-primary text-text-primary'
                  : 'text-red bg-[#FEF3F2]'
              }
              main-transition-colors flex h-fit w-fit cursor-default
              items-center gap-1.5 rounded-full
              px-2
              py-1 
            `}
            >
              {listOfTagsOptions &&
                (listOfTagsOptions?.find(option => option.id === currentId) || {}).caption}
              <CloseIcon
                className={`
                ${!disabled ? 'cursor-pointer' : ''}
                ${type === 'included' ? 'fill-text-primary' : 'fill-red'}`}
                onClick={() => !disabled && onClickTagLabel(currentId)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default TagsBlock
